import { AnalysisStatus } from '@/api/domains/analyses';

export const getChipColor = (status: AnalysisStatus) => {
  const colorMap: Record<
    AnalysisStatus,
    { background: string; color: string }
  > = {
    PENDING: { background: '#e3f2fd', color: '#1565c0' },
    PROCESSING: { background: '#fff3e0', color: '#e65100' },
    COMPLETED: { background: '#e8f5e9', color: '#2e7d32' },
    FAILED: { background: '#ffebee', color: '#c62828' }
  };
  return colorMap[status];
};
